import { NgModule } from '@angular/core';
import { PageMetaResolver } from '@spartacus/core';
import { HomePageMetaResolver } from './home-page-meta.resolver';

@NgModule({
  providers: [
    {
      provide: PageMetaResolver,
      useExisting: HomePageMetaResolver,
      multi: true,
    },
  ],
})
export class SeoResolversModule {}
